import { tableColumnMapper } from "~/utils/tableColumnMapper";

// DataTable
export const columns = {
    openTasks: {
    __graphqlType: 'AufgabeCollection',
    id: { header: 'Id', accessor: 'id' },
    subproject: { header: 'Subprojekt', accessor: 'subprojekt' },
    createdAt: { header: 'Angelegt', accessor: 'angelegt', renderer: { name: 'CreatedAtAndByWhom' }, },
    project: { header: 'Projekt', accessor: 'subprojekt.projekt.lfdNr',width: '300px', renderer: { name: 'ProjectDetails' }, },
    type: { header: 'Typ', accessor: 'subprojekt.projekttyp.name', enableHiding: true, renderer: { name: 'ProjectType' }, },
    task: { header: 'Aufgabe', accessor: 'typSnippet.name' },
    editor: { header: 'Zu erledigen von', accessor: 'sachbearbeiter', renderer: {name: 'Employee'} },
    functions: { header: 'Funktion', accessor: 'funktion.bezeichnung' },
    role: { header: 'Rolle', accessor: 'rolle.bezeichnung' },
    description: { header: 'Beschreibung', accessor: 'beschreibung', renderer: { name: 'Description' } },
    controls: { accessor: 'controls', width: 60, enableSorting: false, renderer: { name: 'Controls' } },
    },
    serviceRequest: {
        address: { header: 'Adresse Schaden / Niederlassung', accessor: 'client', enableSorting: false, renderer: { name: 'ServiceRequestAddress' } },
        branch: { header: 'Niederlassung', accessor: 'branch', enableSorting: false, renderer: { name: 'Branch' } },
        origin: { header: 'Herkunft', accessor: 'sourceSystem.name', enableSorting: false, },
        dates: { header: 'Eingangsdatum', accessor: 'details.receiptDateTime', enableSorting: false, renderer: { name: 'ServiceRequestDateFormat' } },
        type: { header: 'Typ', accessor: 'details.serviceTypes', enableSorting: false, renderer: { name: 'ServiceRequestTypes' } },
        attachments: { header: 'Anhänge', accessor: 'attachments', enableSorting: false, renderer: { name: 'ServiceRequestAttachments' } },
        controls: { accessor: 'controls', width: 60, enableSorting: false, renderer: { name: 'Controls' } },
    }
};

export const tables = { 
    openTasks: {
        columns: [ 'id', 'createdAt', 'project',  'task', 'editor', 'functions', 'role', 'description', 'controls' ].map(tableColumnMapper(columns.openTasks)), 
        hiddenColumns: ['id'], 
    },
    serviceRequest: {
        columns: ['address','origin','type', 'dates', 'attachments', 'controls'].map(tableColumnMapper(columns.serviceRequest)), 
        hiddenColumns: [], 
    }
};

  